import { IEventDispatcher } from "./IEventDispatcher";
import { Event } from "./Event";

export class EventDispatcher implements IEventDispatcher
{
    private _listeners: Object = {};

    constructor()
    {
    }

    addEventListener(type: string, callback: Function, callbackContext: any)
    {
        var registeredObjects: Array<any> = this._listeners[type] || [];
        var callbacks: Array<Function>;

        var len = registeredObjects.length;
        for(var i = 0;i < len;i++)
        {
            if(registeredObjects[i].context == callbackContext)
            {
                callbacks = registeredObjects[i].callbacks;
                break;
            }
        }

        if(!callbacks)
        {
            callbacks = [];
            var object = {context: callbackContext, callbacks: callbacks};
            registeredObjects.push(object);
        }

        len = callbacks.length;
        for(var i = 0;i < len;i++)
        {
            if(callbacks[i] == callback)
                return;
        }

        callbacks.push(callback);
        this._listeners[type] = registeredObjects;
    }

    dispatchEvent(event: Event, target?: any)
    {
        var registeredObjects: Array<any> = this._listeners[event.type];
        if(!registeredObjects)
            return;

        registeredObjects = registeredObjects.slice();

        if(target != undefined)
            event.target = target;
        else
            event.target = this;
        event.currentTarget = this;

        var len = registeredObjects.length;
        var object: any, callbacksLen: number;
        for(var i = 0;i < len;i++)
        {
            object = registeredObjects[i];
            callbacksLen = object.callbacks.length;
            for(var j = 0;j < callbacksLen;j++)
                object.callbacks[j].call(object.context, event);
        }
    }

    removeEventListener(type: string, callback: Function, callbackContext: any)
    {
        var registeredObjects: Array<any> = this._listeners[type];
        if(!registeredObjects)
            return;

        var len = registeredObjects.length;
        var object: any, callbacksLen:number;
        for(var i = 0;i < len;i++)
        {
            object = registeredObjects[i];
            if(object.context != callbackContext)
                continue;

            callbacksLen = object.callbacks.length;
            for(var j = 0;j < callbacksLen;j++)
            {
                if(object.callbacks[j] == callback)
                {
                    object.callbacks.splice(j, 1);
                    j--;
                    callbacksLen--;
                }
            }

            if(callbacksLen == 0)
            {
                registeredObjects.splice(i, 1);
                i--;
                len--;
            }
        }

        if(len == 0)
        {
            delete this._listeners[type];
        }
    }

    hasEventListener(type)
    {
        return this._listeners[type] != undefined;
    }

    dispose()
    {
        for(var type in this._listeners)
            delete this._listeners[type];
    }
}
